import React, { useEffect, useState, useContext } from 'react';
import { getAdminPartById, AddParts } from '../../../../Core/Services/InternalUser/makeService';
import { Grid, FormLabel, InputLabel } from '@material-ui/core';
import { NoButton, SecondaryButton, TextBox, YesButton } from '../../../../Core/Controls';
// import AppContext from './../../../App/AppContext';

const PartsAddUpdate = (props) => {
    const [state, setState] = useState({
        partNumber: '',
        description: '',
        partID: props.partID,
        errors: {},
        isActive: true,
        binLocation: '',
        unitOfStock: '',
        sellingprice: '',
        quantityOnPOrder: ''
    });

    // const { showToast, showModal } = useContext(AppContext);

    useEffect(async () => {
        if (props.partID) {
            let res = await getAdminPartById(props.partID);
            if (res.success) {
                let data = res.data?.table[0];
                setState((st) => ({
                    ...st,
                    partNumber: data?.partNumber,
                    partID: data?.partID,
                    description: data?.description,
                    isActive: data?.isActive,
                    binLocation: data.binLocation,
                    unitOfStock: data.unitOfStock,
                    sellingprice: data.sellingprice,
                    quantityOnPOrder: data.quantityOnPOrder
                }));
            }
        }
    }, []);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        let data = {
            partID: state.partID,
            partNumber: state.partNumber,
            isActive: state.isActive,
            description: state.description,
            binLocation: state.binLocation,
            unitOfStock: state.unitOfStock,
            sellingprice: state.sellingprice,
            quantityOnPOrder: state.quantityOnPOrder
        };
        let res = await AddParts(data);
        if (res.success) {
            // showToast(res.data?.message || `Parts Added Successfully`);
            props.onClose(true);
        } else {
            console.error(res.message);
        }
    };
    const handleClick = (name, val) => {
        setState((st) => {
            const nst = { ...st, [name]: val };
            return nst;
        });
    };
    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <FormLabel component="legend" className="mandatoryfields">
                        Part Number
                    </FormLabel>
                    <TextBox name="partNumber" onChange={handleInput} value={state.partNumber} autoFocus={true} />
                    <span className="mandatoryfields">{state.errors?.partNumber}</span>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormLabel component="legend" className="mandatoryfields">
                        Description
                    </FormLabel>
                    <TextBox name="description" onChange={handleInput} value={state.description} />
                    <span className="mandatoryfields">{state.errors?.description}</span>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <FormLabel component="legend" className="mandatoryfields">
                        Location
                    </FormLabel>
                    <TextBox name="binLocation" onChange={handleInput} value={state.binLocation} />
                    <span className="mandatoryfields">{state.errors?.binLocation}</span>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormLabel component="legend" className="mandatoryfields">
                        Unit
                    </FormLabel>
                    <TextBox name="unitOfStock" onChange={handleInput} value={state.unitOfStock} />
                    <span className="mandatoryfields">{state.errors?.unitOfStock}</span>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormLabel component="legend" className="mandatoryfields">
                        Price
                    </FormLabel>
                    <TextBox name="sellingprice" onChange={handleInput} value={state.sellingprice} />
                    <span className="mandatoryfields">{state.errors?.sellingprice}</span>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormLabel component="legend" className="mandatoryfields">
                        Quantity
                    </FormLabel>
                    <TextBox name="quantityOnPOrder" onChange={handleInput} value={state.quantityOnPOrder} />
                    <span className="mandatoryfields">{state.errors?.quantityOnPOrder}</span>
                </Grid>

                <Grid xs={12} item style={{ marginBottom: 8 }}>
                    <InputLabel shrink>Is Active?</InputLabel>
                    <Grid xs={12} container spacing={1}>
                        <Grid item xs={6}>
                            <YesButton toolTipTitle="Yes" btnName="Yes" state={state.isActive} name="isActive" onClick={() => handleClick('isActive', true)} />
                        </Grid>
                        <Grid item xs={6}>
                            <NoButton toolTipTitle="No" btnName="No" state={state.isActive} name="isActive" onClick={() => handleClick('isActive', false)} />
                        </Grid>
                    </Grid>
                </Grid>

                {/* <Grid item xs={12} sm={12} md={12} container>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Is Active?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.isActive}
                        name="isActive"
                        onYesClick={() => handleClick('isActive', true)}
                        onNoClick={() => handleClick('isActive', false)}
                    />
                </Grid> */}
                <Grid item xs={12} style={{ marginBottom: 20 }}>
                    <SecondaryButton fullWidth onClick={handleSubmit}>
                        Save
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default PartsAddUpdate;
